import CurpMediaContainer from './CurpMediaContainer';

export default CurpMediaContainer;
